import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import CrossIcon from "../../../../../icons/cross.icon";
import styles from "./archive-modal.module.scss";

export const ArchiveModal = ({ show = false, onHide, onSave, companyNames = [] }) => {
  const [showNotArchiveContent, setShowNotArchiveContent] = useState(false);
  const accountCount = companyNames.length;

  // Reset state when modal is closed
  React.useEffect(() => {
    if (!show) {
      setTimeout(() => {
        setShowNotArchiveContent(false);
      }, 500);
    }
  }, [show]);

  const handleSave = () => {
    if (onSave) {
      onSave();
    }
    setShowNotArchiveContent(true);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="archive-modal-dialog"
      className={styles.modal}
      aria-labelledby="archive-modal-title"
      aria-describedby="archive-modal-description"
    >
      <Modal.Header className={styles.headerContainer}>
        <div className={styles.headerContent}>
          <div className={styles.closeButtonWrapper}>
            <button
              className={styles.closeButton}
              onClick={onHide}
              type="button"
              aria-label="Close dialog"
            >
              <CrossIcon fill="#616778" width={10} height={10} />
            </button>
          </div>

          <div className={styles.titleWrapper}>
            <h2 className={styles.title} id="archive-modal-title">
              Archive
            </h2>
          </div>
        </div>

        <div className={styles.dividerWrapper}>
          <div style={{ borderTop: "1px solid rgba(235, 237, 241, 1)", width: "100%" }} />
        </div>
      </Modal.Header>

      <Modal.Body className={styles.content} id="archive-modal-description">
        {showNotArchiveContent ? (
          <NotArchiveModalBody styles={styles} companyNames={companyNames} />
        ) : (
          <div className={styles.description}>
            <p className={styles.paragraph}>
              You are about to archive{" "}
              <strong className={styles.strong}>
                {accountCount} MSP account{accountCount !== 1 ? "s" : ""}
              </strong>
              :
            </p>

            <ul className={styles.list}>
              {companyNames.map((companyName, index) => (
                <li key={index} className={styles.listItem}>
                  {companyName}
                </li>
              ))}
            </ul>

            <p className={styles.paragraph}>
              Archiving will retain their information until you permanently delete
              the accounts. Trial history is always saved, so no new trial will be
              granted in the future. If these companies return, they must create a
              new account and choose a paid plan during setup.
            </p>
          </div>
        )}
      </Modal.Body>

      {!showNotArchiveContent && (
        <Modal.Footer className={styles.footer}>
          <div className={styles.footerContent}>
            <button
              className={styles.cancelButton}
              onClick={onHide}
              type="button"
            >
              Cancel
            </button>
            <div className={styles.buttonGroup}>
              <button
                className={styles.saveButton}
                onClick={handleSave}
                type="button"
              >
                Save
              </button>
            </div>
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};



export const NotArchiveModalBody = ({ styles: componentStyles, companyNames = [] }) => {
  const firstCompanyName = companyNames.length > 0 ? companyNames[0] : "[Company Name]";
  
  const contentData = {
    introText: "These MSP accounts cannot be archived:",
    companyName: firstCompanyName,
    statusText: "SUSPENDED",
    closingText:
      "accounts can be archived. Please update the status of these accounts before trying again.",
  };

  return (
    <div className={componentStyles.notArchiveContainer}>
      <p className={componentStyles.notArchiveParagraph}>
        <span className={componentStyles.notArchiveText}>
          {contentData.introText}
          <br />
          <br />
          {contentData.companyName} <br />
          <br />
          Only{" "}
        </span>
        <span className={componentStyles.notArchiveStatusText}>
          {contentData.statusText}{" "}
        </span>
        <span className={componentStyles.notArchiveText}>
          {contentData.closingText}
        </span>
      </p>
    </div>
  );
};